import { frFR } from "@material-ui/data-grid";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import React, {
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import navContext from "../../../Context/navContext";
import {
  MdDownload,
  MdEdit,
  MdOutlineRemoveRedEye,
  MdWarning,
} from "react-icons/md";
import notifyContext from "../../../Context/notifyContext";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../../Loader/Loader";
import Modal from "../../../Modal/Modal";
import FormDocument from "../../../Main/Components/Document/Form/FormDocument";
import {
  downloadfile,
  findAllByFolder,
} from "../../../../services/File__Servive";
import { findOne } from "../../../../services/Folder__Service";
import FormFile from "./FormFile/FormFile";
import { securitySalarie } from "../../../../services/Auth__Service";

const ListFile = () => {
  /* Handle Modal */
  const [viewFileId, setViewFileId] = useState(0);
  const [modifyFileId, setModifyFileId] = useState(0);
  const [showAdd, setShowAdd] = useState(false);
  /* End Handle Modal */

  const paramsRoutes = useParams();

  const [id, setId] = useState(paramsRoutes.id);

  const [folder, setFolder] = useState(null);
  const [salarie, setSalarie] = useState(null);
  const [files, setFiles] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingFolder, setIsLoadingFolder] = useState(true);
  const [isLoadingFiles, setIsLoadingFiles] = useState(true);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const nav = useContext(navContext);
  const notify = useContext(notifyContext);

  const redirect = useNavigate();

  const downloadHandle = React.useCallback(
    (filename, nameDownload) => () => {
      downloadfile(filename, nameDownload);
    },
    []
  );

  const columns = useMemo(
    () => [
      {
        field: "Nom",
        headerName: "Nom",
        minWidth: 200,
        flex: 1,
        valueGetter: (params) => {
          return params.row.name;
        },
      },
      {
        field: "Date",
        headerName: "Date",
        minWidth: 110,
        type: "date",
        valueGetter: (params) => {
          return new Date(params.row.date_create).toLocaleDateString("fr-FR");
        },
      },

      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        width: 100,
        getActions: (params) => [
          <GridActionsCellItem
            icon={<MdDownload />}
            label="Télécharger"
            onClick={downloadHandle(
              params.row.filename,
              params.row.nameDownload
            )}
            showInMenu
          />,
          <GridActionsCellItem
            icon={<MdOutlineRemoveRedEye />}
            label="Voir"
            onClick={() => setViewFileId(params.id)}
            showInMenu
          />,
        ],
      },
    ],
    [downloadHandle]
  );

  useEffect(() => {
    nav({
      links: [
        {
          href: "/salarie/" + paramsRoutes.salarieId + "/folder/",
          linkname: "Dossiers",
        },
        {
          href: "",
          linkname: folder ? folder.name : "",
        },
      ],

      children: "",
    });

    if (folder) {
      securitySalarie(folder.salarie.id);
    }
  }, [folder]);

  useEffect(() => {
    fetchOneFolder(id);
  }, []);

  useEffect(() => {
    if (!showAdd) {
      setIsLoading(true);
      setIsLoadingFiles(true);
      fetchAllFileByFolder(id);
    }
  }, [showAdd]);

  useEffect(() => {
    if (!isLoadingFiles && !isLoadingFolder) {
      let list = files.map((file) => {
        return {
          ...file,
        };
      });
      setIsLoading(false);
      setFiles(list);
    }
  }, [isLoadingFolder, isLoadingFiles]);

  const fetchOneFolder = async (id) => {
    findOne(id)
      .then((response) => {
        setFolder(response.data);
        setIsLoadingFolder(false);
      })
      .catch((error) => {
        setIsLoadingFolder(false);
      });
  };

  const fetchAllFileByFolder = async (id) => {
    findAllByFolder(id)
      .then((response) => {
        setFiles(response.data);
        setIsLoadingFiles(false);
      })
      .catch((error) => {
        setIsLoadingFiles(false);
      });
  };

  const handleChangeRowsPerPage = (numberRow) => {
    setRowsPerPage(parseInt(numberRow, 10));
  };

  return (
    <Fragment>
      <div className="file__items">
        <div style={{ height: "100%", width: "100%", background: "#fff" }}>
          <DataGrid
            rows={files}
            columns={columns}
            pageSize={rowsPerPage}
            rowsPerPageOptions={[10, 25, 50, 100]}
            loading={isLoading}
            onPageSizeChange={handleChangeRowsPerPage}
            localeText={frFR.props.MuiDataGrid.localeText}
          />
        </div>
      </div>
      {isLoading && <Loader loadingMsg="Chargement" />}

      {viewFileId !== 0 && (
        <Modal>
          <div className="modal modal--show">
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Détails du Fichier</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setViewFileId(0)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <FormFile fileId={viewFileId} view={true} />
              </div>
              <div className="modal__footer">
                <button className="btn" onClick={() => setViewFileId(0)}>
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {modifyFileId !== 0 && (
        <Modal>
          <div className="modal modal--show">
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Modification du Fichier</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setModifyFileId(0)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <FormFile fileId={modifyFileId} modify={true} />
              </div>
            </div>
          </div>
        </Modal>
      )}

      {showAdd && (
        <Modal>
          <div className="modal modal--show">
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Ajouter un Fichier</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setShowAdd(false)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <FormFile setShowAdd={setShowAdd} />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </Fragment>
  );
};

export default ListFile;
